(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-share"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-share')) {
    customElements.define(
      'product-share',
      class ProductShare extends HTMLElement {
        connectedCallback() {
          this.button = this.querySelector('[data-share-button]');
          this.status = this.querySelector('[data-share-status]');
          this.onClick = this.share.bind(this);
          this.button.addEventListener('click', this.onClick);
        }

        disconnectedCallback() {
          this.button?.removeEventListener('click', this.onClick);
          clearTimeout(this.statusTimeout);
        }

        async share() {
          const { url, title } = this.dataset;

          if (navigator.share) {
            try {
              await navigator.share({ url, title });
            } catch (error) {
              // Dismissing the share sheet rejects with AbortError - nothing to do.
            }
            return;
          }

          try {
            await navigator.clipboard.writeText(url);
            this.showStatus(this.status.dataset.message);
          } catch (error) {
            window.prompt('', url);
          }
        }

        showStatus(message) {
          this.status.textContent = message;
          clearTimeout(this.statusTimeout);
          this.statusTimeout = setTimeout(() => {
            this.status.textContent = '';
          }, 3000);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
